import api from './api';

const statutsParkingApi = {
  getAll:  ()         => api.get('/statuts-parking'),
  create:  (data)     => api.post('/statuts-parking', data),
  update:  (id, data) => api.put(`/statuts-parking/${id}`, data),
  delete:  (id)       => api.delete(`/statuts-parking/${id}`),
};

export default statutsParkingApi;
